<template>
  <v-dialog
    v-model="opened"
    content-class="reset-pass"
    max-width="370"
    persistent
  >
    <h3 class="reset-pass__title">{{ $t('setPassword.button') }}</h3>

    <v-btn class="close-btn" icon @click="opened = false">
      <v-icon size="27" color="#464646"> mdi-close-circle-outline </v-icon>
    </v-btn>

    <v-form ref="reset-pass" @submit.prevent="onSubmit">
      <v-text-field
        v-model="password"
        dense
        outlined
        :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
        :type="showPass ? 'text' : 'password'"
        :label="$t('common.fields.passwordPlaceholder')"
        :rules="[isRequired]"
        @click:append="showPass = !showPass"
      />
      <v-text-field
        v-model="password_confirmation"
        dense
        outlined
        :append-icon="showConfirm ? 'mdi-eye' : 'mdi-eye-off'"
        :type="showConfirm ? 'text' : 'password'"
        :label="$t('common.fields.repeatPlaceholder')"
        :rules="[isRequired, isPasswordsSame]"
        @click:append="showConfirm = !showConfirm"
      />

      <v-btn
        color="warning"
        type="submit"
        elevation="0"
        block
        :loading="loading"
        >{{ $t('common.btns.save') }}</v-btn
      >
    </v-form>
  </v-dialog>
</template>

<script>
export default {
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    id: {
      type: [String, Boolean],
      required: true,
    },
  },
  data: () => ({
    loading: false,
    showPass: false,
    showConfirm: false,
    password: '',
    password_confirmation: '',
  }),
  computed: {
    opened: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit('change', v);
      },
    },
  },
  methods: {
    isRequired(v) {
      return !!v || this.$t('common.fields.validation.field.required');
    },
    isPasswordsSame(v) {
      return (
        // eslint-disable-next-line
        v === this.password ||
        this.$t('common.fields.validation.password.dontMatch')
      );
    },
    async onSubmit() {
      const isValid = this.$refs['reset-pass'].validate();

      if (!isValid) return;

      this.loading = true;

      const params = {
        password: this.password,
        password_confirmation: this.password_confirmation,
      };

      const result = await this.$store.dispatch('employees/updateItem', {
        id: this.id,
        params,
      });

      this.loading = false;
      this.$emit('updated', result);
    },
  },
};
</script>

<style lang="scss">
.reset-pass {
  padding: 10px;
  background-color: #fff;

  &__title {
    text-align: center;
    font-size: 18px;
    color: #464646;
    margin-bottom: 20px;
  }
}
</style>
